import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import guestRFQCartHandler from "@WhiteCap/Handlers/GuestRFQ/GuestRFQCartHandler";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

// Map state to props
const mapStateToProps = (state: CustomApplicationState) => {
    const newUrl = getLocation(state);
    const isAuthenticated = state.context.session.isAuthenticated;
    const searchParams = parseQueryString<{ GuestCartId: string }>(getLocation(state).search);
    let quoteCartId = searchParams?.GuestCartId;
    return {
        newUrl,
        isAuthenticated,
        quoteCartId,
    };
};

const mapDispatchToProps =  {
    guestRFQCartHandler,
}

type Props = ReturnType<typeof mapStateToProps> & HasHistory & ResolveThunks<typeof mapDispatchToProps>;

export interface GuestSuccessPageStyles {
    succeessPageWrapper?: InjectableCss;
    cartSuccess?: InjectableCss;
}

export const guestSuccessPageStyles: GuestSuccessPageStyles = {
    succeessPageWrapper: {
        css: css`
            h1 {
                font-size: 26px;
                line-height: 32px;
                letter-spacing: 0.5px;
                text-transform: none;
                font-weight: 700;
                margin-bottom: 10px;
            }
            p {
                margin-bottom: 40px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        h1 {
                            font-size: 20px;
                            letter-spacing: 0px;
                        }
                        p {
                            margin-bottom: 20px;
                        }
                    `,
                    css`
                        h1 {
                            font-size: 20px;
                            letter-spacing: 0px;
                        }
                        p {
                            margin-bottom: 20px;
                        }
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
};

const styles = guestSuccessPageStyles;

const GuestCustomerSuccess = ({ history, newUrl, isAuthenticated, quoteCartId, guestRFQCartHandler }: Props) => {
    
    // Use effect to handle redirection based on URL conditions
    useEffect(() => {
        // Check if URL contains "/Content/Page"
        if (newUrl.pathname.includes("/Content/Page")) {
            // Don't do anything, just display the page
            return;
        }

        // Check if URL contains "quote-confirmation" and formSubmitted is not present in localStorage
        if (newUrl.pathname.includes("quote-confirmation")) {
            const isFormSubmitted = sessionStorage.getItem("formSubmitted");
            if (!isFormSubmitted || isAuthenticated) {
                history.push("/");
            }
            sessionStorage.removeItem("formSubmitted");
            sessionStorage.removeItem("sameAsBilling");
            localStorage.removeItem("rfqCart");
            sessionStorage.removeItem("guestRfqFormData");
            guestRFQCartHandler({quoteCount: 0})
        }
    }, [newUrl, history]);

    const RedirectButton = () => {
        history.push("/");
    };

    return (
        <StyledWrapper {...styles.cartSuccess}>
            <StyledWrapper {...styles.succeessPageWrapper}>
                <StyledWrapper>
                    <Typography as="h1">{siteMessage("Guest_Cart_Success_Message")}</Typography>
                    <Typography as="p">{translate(`Your Quote Request id is: ${quoteCartId}`)}</Typography>
                </StyledWrapper>
            </StyledWrapper>
            <Button onClick={RedirectButton}>{translate("Continue Shopping")}</Button>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(GuestCustomerSuccess)),
    definition: {
        displayName: "Guest User Success Page",
        group: "Common",
    },
};

export default widgetModule;
